// Elimina el orden de una definición de reporte cuando su campo ya no está
// entre las métricas ni dimensiones seleccionadas (el backend rechaza esa
// combinación). Ocurre al cargar un reporte guardado —cuya definición trae
// orden— y luego editar la selección en el constructor, que no muestra el orden.
export function podarOrden(defn) {
  if (!defn.orden) return defn;
  const campos = [...(defn.metricas || []), ...(defn.dimensiones || [])];
  if (campos.includes(defn.orden.campo)) return defn;
  const { orden, ...sinOrden } = defn;
  return sinOrden;
}
